import { cx } from "shared/utils";
import { SkeletonCell } from "./SkeletonCell";
import { HeaderGroup } from "@tanstack/react-table";

export const SkeletonBody = ({
  emptyRowsNumber,
  headerGroup,
  tdClassName,
  onRowClick,
  rowHeight
}: {
  emptyRowsNumber: number;
  onRowClick?: (rowId: string, rowData?: any) => void;
  tdClassName?: string;
  headerGroup: HeaderGroup<any>[];
  rowHeight?: string;
}) =>
  Array(emptyRowsNumber)
    .fill("_")
    .map((_, idx) => {
      return (
        <tr
          key={`skeleton_row_${idx}`}
          className={cx(
            "border-b border-alpha-40 text-content-100 last-of-type:border-b-0",
            onRowClick ? "cursor-pointer hover:bg-alpha-40" : ""
          )}
        >
          {headerGroup[0].headers.map((header, cellIdx) => {
            const size = header.getSize();
            const isActionCell =
              header.id === "popover-action" || header.id === "expander";
            const fixedWidth =
              header.id.includes("fixed_width") || isActionCell
                ? size
                : undefined;
            return (
              <td
                key={`skeleton_row_${idx}_cell_${cellIdx}`}
                style={
                  size && !isNaN(size)
                    ? {
                        minWidth: size,
                        width: fixedWidth,
                        height: rowHeight
                      }
                    : {
                        height: rowHeight
                      }
                }
              >
                <div
                  className={cx(
                    "box-border animate-appear flex items-center xl:px-4 px-1",
                    tdClassName
                  )}
                >
                  <SkeletonCell />
                </div>
              </td>
            );
          })}
        </tr>
      );
    });
